/* =============================================================
   DAR_CUSTOM: محوّل العملة المخصص — DarCurrencyConverter v3
   يحوّل الأسعار من OMR إلى عملة العرض حسب الماركت

   المتجر لا يستخدم Shopify Payments — كل الأسواق بـ OMR
   كل ماركت = عملة عرض واحدة

   الملف: dar-currency-converter.js
   عند تحديث الثيم: انسخ هذا الملف كاملاً بدون تعديل
   ============================================================= */
(function () {
  'use strict';

  // ══════════════════════════════════════════════════════════════
  //  الإعدادات — ماركت واحد = عملة واحدة
  // ══════════════════════════════════════════════════════════════

  var BASE_CURRENCY = 'OMR';

  // خريطة الماركت → العملة (تطابق URL: /en-sa/, /en-eu/, etc.)
  var MARKET_CURRENCY = {
    'SA': 'SAR',
    'AE': 'AED',
    'KW': 'KWD',
    'BH': 'BHD',
    'QA': 'QAR',
    'EU': 'EUR',
    'US': 'USD',
    'GB': 'GBP'
  };

  // خريطة البلد → العملة (احتياطي إذا لم نتعرف من URL)
  var COUNTRY_CURRENCY = {
    'OM': 'OMR',
    'SA': 'SAR', 'AE': 'AED', 'KW': 'KWD',
    'BH': 'BHD', 'QA': 'QAR', 'US': 'USD', 'GB': 'GBP',
    // كل الدول الأوروبية → EUR (ماركت واحد)
    'DE': 'EUR', 'FR': 'EUR', 'IT': 'EUR', 'ES': 'EUR',
    'NL': 'EUR', 'BE': 'EUR', 'AT': 'EUR', 'IE': 'EUR',
    'PT': 'EUR', 'FI': 'EUR', 'GR': 'EUR', 'LU': 'EUR',
    'SK': 'EUR', 'SI': 'EUR', 'EE': 'EUR', 'LV': 'EUR',
    'LT': 'EUR', 'CY': 'EUR', 'MT': 'EUR', 'HR': 'EUR',
    'SE': 'EUR', 'DK': 'EUR', 'NO': 'EUR', 'PL': 'EUR',
    'CH': 'EUR', 'RO': 'EUR', 'IS': 'EUR', 'CZ': 'EUR', 'HU': 'EUR'
  };

  // تنسيق العملات
  var CURRENCY_FORMAT = {
    'OMR': { symbol: 'OMR', decimals: 3, before: false },
    'SAR': { symbol: 'SAR', decimals: 2, before: false },
    'AED': { symbol: 'AED', decimals: 2, before: false },
    'KWD': { symbol: 'KWD', decimals: 3, before: false },
    'BHD': { symbol: 'BHD', decimals: 3, before: false },
    'QAR': { symbol: 'QAR', decimals: 2, before: false },
    'USD': { symbol: '$',   decimals: 2, before: true },
    'GBP': { symbol: '£',   decimals: 2, before: true },
    'EUR': { symbol: '€',   decimals: 2, before: true }
  };

  // أسعار صرف مضمنة — تُستخدم فوراً بدون طلب شبكة
  var DEFAULT_RATES = {
    'OMR': 1.0, 'SAR': 9.75, 'AED': 9.55,
    'KWD': 0.8, 'BHD': 0.98, 'QAR': 9.5,
    'USD': 2.6, 'GBP': 2.05, 'EUR': 2.38
  };

  var CACHE_KEY = 'dar_currency_rates';
  var COUNTRY_KEY = 'dar_last_country';
  var CACHE_DURATION = 24 * 60 * 60 * 1000;
  var API_URL = 'https://open.er-api.com/v6/latest/OMR';

  // ══════════════════════════════════════════════════════════════
  //  1. كشف العملة — URL أولاً، ثم data-country
  // ══════════════════════════════════════════════════════════════

  function detectCurrency() {
    // المصدر 1: URL — مثل /en-sa/ أو /ar-eu/ أو /en-gb/
    var urlMatch = window.location.pathname.match(/^\/(ar|en)-([a-z]{2,3})\//i);
    if (urlMatch) {
      var marketCode = urlMatch[2].toUpperCase();
      if (MARKET_CURRENCY[marketCode]) {
        return { market: marketCode, currency: MARKET_CURRENCY[marketCode] };
      }
    }

    // المصدر 2: data-country من Liquid
    var scriptTag = document.querySelector('script[src*="dar-currency-converter"]');
    if (scriptTag) {
      var country = (scriptTag.dataset.country || '').toUpperCase();
      if (country && COUNTRY_CURRENCY[country]) {
        return { market: country, currency: COUNTRY_CURRENCY[country] };
      }
    }

    // افتراضي: عُمان
    return { market: 'OM', currency: BASE_CURRENCY };
  }

  // ══════════════════════════════════════════════════════════════
  //  2. سعر الصرف — cache أولاً، ثم DEFAULT_RATES
  // ══════════════════════════════════════════════════════════════

  function getRate(targetCurrency) {
    // محاولة من localStorage
    try {
      var cached = localStorage.getItem(CACHE_KEY);
      if (cached) {
        var data = JSON.parse(cached);
        if (data.timestamp && (Date.now() - data.timestamp) < CACHE_DURATION && data.rates[targetCurrency]) {
          return data.rates[targetCurrency];
        }
      }
    } catch (e) { /* تجاهل */ }

    // أسعار افتراضية مضمنة
    return DEFAULT_RATES[targetCurrency] || null;
  }

  function fetchFreshRates(callback) {
    fetch(API_URL)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.rates) return;
        var rates = {};
        Object.keys(DEFAULT_RATES).forEach(function (cur) {
          rates[cur] = data.rates[cur] || DEFAULT_RATES[cur];
        });
        rates[BASE_CURRENCY] = 1.0;

        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify({
            rates: rates, timestamp: Date.now()
          }));
        } catch (e) { /* ممتلئ */ }

        callback(rates);
      })
      .catch(function () { /* فشل — الافتراضية مُطبقة */ });
  }

  // ══════════════════════════════════════════════════════════════
  //  3. أدوات التنسيق
  // ══════════════════════════════════════════════════════════════

  function formatPrice(amount, currencyCode) {
    var fmt = CURRENCY_FORMAT[currencyCode] || CURRENCY_FORMAT[BASE_CURRENCY];
    var parts = amount.toFixed(fmt.decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var formatted = parts.join('.');
    return fmt.before ? (fmt.symbol + formatted) : (formatted + ' ' + fmt.symbol);
  }

  function extractAmount(text) {
    if (!text) return null;
    var cleaned = text.replace(/[^\d.,]/g, '');
    if (!cleaned) return null;
    if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
      cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    } else {
      cleaned = cleaned.replace(/,/g, '');
    }
    var num = parseFloat(cleaned);
    return isNaN(num) ? null : num;
  }

  // ══════════════════════════════════════════════════════════════
  //  4. التحويل
  // ══════════════════════════════════════════════════════════════

  function convertElement(el, rate, currency) {
    if (el.classList && el.classList.contains('sr-only')) return;

    if (!el.dataset.darOrig) {
      el.dataset.darOrig = el.textContent.trim();
      var amt = extractAmount(el.textContent);
      el.dataset.darAmt = (amt !== null) ? amt.toString() : '';
    }

    var originalAmt = parseFloat(el.dataset.darAmt);
    if (isNaN(originalAmt) || originalAmt === 0) return;

    var prefix = '';
    if (/^from\s/i.test(el.dataset.darOrig)) prefix = 'From ';
    else if (/^من\s/.test(el.dataset.darOrig)) prefix = 'من ';

    el.textContent = prefix + formatPrice(originalAmt * rate, currency);
  }

  function convertTextNodes(root, rate, currency) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        var tag = p.tagName.toLowerCase();
        if (tag === 'script' || tag === 'style' || tag === 'noscript' ||
            tag === 'textarea' || tag === 'input') return NodeFilter.FILTER_REJECT;
        if (p.classList && p.classList.contains('sr-only')) return NodeFilter.FILTER_REJECT;
        return (node.textContent && node.textContent.indexOf('OMR') !== -1)
          ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });

    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(function (n) {
      var text = n.textContent;
      // "OMR 5.700" أو "OMR5.700"
      var result = text.replace(/OMR\s*([\d,]+\.?\d*)/gi, function (_, num) {
        var a = extractAmount(num);
        return (a !== null && a > 0) ? formatPrice(a * rate, currency) : _;
      });
      // "5.700 OMR"
      result = result.replace(/([\d,]+\.\d{2,3})\s*OMR/gi, function (_, num) {
        var a = extractAmount(num);
        return (a !== null && a > 0) ? formatPrice(a * rate, currency) : _;
      });
      if (result !== text) n.textContent = result;
    });
  }

  function convertAll(rate, currency) {
    document.querySelectorAll(
      'sale-price, compare-at-price, unit-price, .cart-drawer__button-price'
    ).forEach(function (el) { convertElement(el, rate, currency); });
    convertTextNodes(document.body, rate, currency);
  }

  function reConvert(rate, currency) {
    document.querySelectorAll(
      'sale-price, compare-at-price, unit-price, .cart-drawer__button-price'
    ).forEach(function (el) {
      if (el.classList && el.classList.contains('sr-only')) return;
      if (!el.dataset.darOrig) {
        var a = extractAmount(el.textContent);
        if (a !== null && a > 0) {
          el.dataset.darAmt = a.toString();
          el.dataset.darOrig = el.textContent.trim();
          convertElement(el, rate, currency);
        }
      } else {
        var txt = el.textContent.trim();
        if (txt.indexOf(BASE_CURRENCY) !== -1 || txt === el.dataset.darOrig) {
          var newAmt = extractAmount(txt);
          if (newAmt !== null) {
            el.dataset.darAmt = newAmt.toString();
            el.dataset.darOrig = txt;
            convertElement(el, rate, currency);
          }
        }
      }
    });
    convertTextNodes(document.body, rate, currency);
  }

  // ══════════════════════════════════════════════════════════════
  //  5. مراقب التغييرات الديناميكية
  // ══════════════════════════════════════════════════════════════

  function startObserver(rate, currency) {
    var obs = new MutationObserver(function (muts) {
      var needed = false;
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.textContent && t.textContent.indexOf('OMR') !== -1) { needed = true; break; }
        if (t.nodeType === 1) {
          var tag = t.tagName && t.tagName.toLowerCase();
          if (tag === 'sale-price' || tag === 'compare-at-price' ||
              tag === 'unit-price' || tag === 'price-list' ||
              tag === 'cart-drawer') { needed = true; break; }
        }
      }
      if (needed) {
        clearTimeout(window._darTimer);
        window._darTimer = setTimeout(function () { reConvert(rate, currency); }, 100);
      }
    });

    obs.observe(document.body, { childList: true, subtree: true, characterData: true });

    document.addEventListener('theme:loading:end', function () {
      setTimeout(function () { reConvert(rate, currency); }, 200);
    });

    return obs;
  }

  // ══════════════════════════════════════════════════════════════
  //  6. نقطة الدخول
  // ══════════════════════════════════════════════════════════════

  function init() {
    var detected = detectCurrency();
    var currency = detected.currency;
    var market = detected.market;

    // عُمان — لا تحويل
    if (currency === BASE_CURRENCY) return;

    // مسح cache عند تغيير الماركت
    try {
      var last = localStorage.getItem(COUNTRY_KEY);
      if (last && last !== market) localStorage.removeItem(CACHE_KEY);
      localStorage.setItem(COUNTRY_KEY, market);
    } catch (e) { /* تجاهل */ }

    // ── تحويل فوري ──
    var rate = getRate(currency);
    var currentObs = null;

    if (rate && rate !== 1) {
      convertAll(rate, currency);
      currentObs = startObserver(rate, currency);

      // تحديث زر الهيدر
      document.querySelectorAll('.dar-locale-trigger__text').forEach(function (t) {
        if (t.textContent.indexOf('OMR') !== -1) {
          t.textContent = t.textContent.replace(/OMR/i, currency);
        }
      });
    }

    // ── تحديث صامت من API ──
    fetchFreshRates(function (rates) {
      var fresh = rates[currency];
      if (!fresh || fresh === 1) return;

      if (!rate || rate === 1) {
        convertAll(fresh, currency);
        startObserver(fresh, currency);
        document.querySelectorAll('.dar-locale-trigger__text').forEach(function (t) {
          if (t.textContent.indexOf('OMR') !== -1)
            t.textContent = t.textContent.replace(/OMR/i, currency);
        });
        return;
      }

      // تحديث صامت إذا الفرق > 1%
      if (Math.abs(fresh - rate) / rate > 0.01) {
        if (currentObs) currentObs.disconnect();
        document.querySelectorAll('[data-dar-amt]').forEach(function (el) {
          convertElement(el, fresh, currency);
        });
        convertTextNodes(document.body, fresh, currency);
        startObserver(fresh, currency);
      }
    });
  }

  // ══════════════════════════════════════════════════════════════

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
